import { TopNavigation } from "components/navigations";
import { FC, useState } from "react";

import { LayoutProps } from "./Layout.types";

export const DashboardLayout: FC<LayoutProps> = ({ children, bgColor }) => {
  const [scrollPosition, setScrollPosition] = useState(0);
  return (
    <main
      className={`min-w-full h-screen ${bgColor} overflow-y-auto`}
      onScroll={e => setScrollPosition(e.currentTarget.scrollTop)}
    >
      <TopNavigation shadow={scrollPosition > 0} />
      {children}
    </main>
  );
};
